import React, { useEffect } from 'react';
import Menu from 'components/QuickTurn/Menu';
import QuickTurnPartStore from 'stores/QuickTurnPartStore';
import { Breadcrumb, Button, Card, Col, Divider, Empty, Row, Tag } from 'antd';
import { observer } from 'mobx-react-lite';
import { Price, ThreeJSThumbnail } from '@partsbadger/library';
import { QuickTurnSalesOrderLineItem } from '@partsbadger/types';
import moment from 'moment';
import { Link } from 'react-router-dom';

const OrderHistory = () => {
    useEffect(() => {
        QuickTurnPartStore.getSalesOrders();
    }, []);

    return (
        <>
            <Menu title="Order History" />

            <div className="container">
                <Breadcrumb>
                    <Breadcrumb.Item>
                        <Link to="/quick-turn/design">QuickTurn</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>Order History</Breadcrumb.Item>
                </Breadcrumb>

                {!QuickTurnPartStore.loading && !QuickTurnPartStore.salesOrders?.length ? (
                    <>
                        <Empty image={null} description={<span className="font-size-lg">No Orders</span>}>
                            <Link to="/quick-turn/design" className="ant-btn ant-btn-primary">
                                Design a Part
                            </Link>
                        </Empty>
                    </>
                ) : (
                    QuickTurnPartStore.salesOrders?.map(so => {
                        return (
                            <Card key={so?.name} className="mt-3 shadow-sm" bodyStyle={{ padding: 0 }}>
                                <div className="d-flex flex-sm-row flex-column justify-content-between p-3">
                                    <div className="d-flex flex-column">
                                        <div className="d-flex flex-row">
                                            <span className="font-size-md font-weight-semibold mr-2">{so?.name}</span>
                                            <Tag color={so?.status !== 'Cancelled' ? 'green' : 'red'}>{so?.status}</Tag>
                                        </div>

                                        <span>{moment(so?.payment_date).format('MM/DD/YYYY')}</span>
                                    </div>
                                    <span className="d-flex flex-row align-items-baseline" style={{ columnGap: '8px' }}>
                                        <span>Total:</span>
                                        <span className="font-size-md font-weight-semibold">
                                            <Price value={so?.grand_total} />
                                        </span>
                                    </span>
                                </div>
                                <Divider className="m-0 p-0" />
                                <div className="p-3 w-100">
                                    <Row gutter={[36, 0]}>
                                        <Col md={12} span={24}>
                                            <div className="mb-3">
                                                {so?.line_items?.map((item: QuickTurnSalesOrderLineItem) => (
                                                    <div key={item.id} className="mb-2">
                                                        <div className="d-flex flex-row">
                                                            <div className="mr-3 d-sm-block d-none">
                                                                <ThreeJSThumbnail
                                                                    id={item.part.id}
                                                                    size="75px"
                                                                    edges={false}
                                                                    background="#ffffff"
                                                                />
                                                            </div>
                                                            <div className="d-flex flex-row justify-content-between align-items-center w-100">
                                                                <div className="d-flex flex-column">
                                                                    <div className="d-flex flex-column">
                                                                        <div className="d-flex flex-column">
                                                                            <span className="font-size-base font-weight-semibold">
                                                                                {item.part.name}
                                                                            </span>

                                                                            <span className="font-size-base text-dark">{`${item.part.material.type} ${item.part.material.alloy}`}</span>
                                                                        </div>
                                                                    </div>

                                                                    <span className="font-size-base font-weight-semibold">
                                                                        Qty:{' '}
                                                                        <span className="font-weight-normal">
                                                                            {item.part.quantity}
                                                                        </span>
                                                                    </span>
                                                                </div>
                                                                <div className="d-flex flex-column justify-content-center align-items-start ml-3 mb-xl-3">
                                                                    <div className="d-flex flex-column justify-content-center ml-3">
                                                                        <span className="font-size-normal text-right">
                                                                            <Price value={item.unit_price} /> ea.
                                                                        </span>
                                                                        <span className="font-size-md font-weight-semibold text-right">
                                                                            <Price value={item.total_price} />
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* {index !== so?.line_items?.length - 1 ? (
                                                    <Divider className="my-1" />
                                                ) : null} */}
                                                    </div>
                                                ))}
                                                {/* <div
                                                style={{
                                                    position: 'absolute',
                                                    bottom: 0,
                                                    left: 0,
                                                    background:
                                                        'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 80%)',
                                                    height: '100px',
                                                    width: '100%',
                                                }}
                                            >
                                                <div className="d-flex align-items-end justify-content-center w-100 h-100">
                                                    <Button type="default" size="small">
                                                        View All Parts
                                                    </Button>
                                                </div>
                                            </div> */}
                                            </div>
                                        </Col>
                                        <Col md={12} span={24}>
                                            <Card className="mb-3">
                                                <div className="mb-3">
                                                    <div className="font-size-md font-weight-semibold mb-1">
                                                        Shipping Address
                                                    </div>
                                                    <div className="d-flex flex-column">
                                                        <div className="d-flex flex-column">
                                                            <span className="font-size-base">{so?.shipping_name}</span>
                                                            <span className="font-size-base">{`${so?.shipping_street}`}</span>
                                                            <span className="font-size-base">
                                                                {`${so?.shipping_city}, ${so?.shipping_state}, ${so?.shipping_zip_code}`}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="mb-3">
                                                    <div className="font-size-md font-weight-semibold mb-1">
                                                        Billing Details
                                                    </div>

                                                    <div className="d-flex flex-column">
                                                        <div className="d-flex flex-column">
                                                            <span className="font-size-base">{so?.billing_name}</span>
                                                            <span className="font-size-base">{`${so?.billing_street}`}</span>
                                                            <span className="font-size-base">
                                                                {`${so?.billing_city}, ${so?.billing_state}, ${so?.billing_zip_code}`}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    className="d-flex font-size-base mb-3"
                                                    style={{ columnGap: '6px' }}
                                                >
                                                    <span className="font-weight-semibold">Credit Card:</span>
                                                    <span>{`${so?.payment_details?.card_brand} **** **** **** ${so?.payment_details?.last_4}`}</span>
                                                </div>

                                                <div className="d-flex flex-column">
                                                    <div className="d-flex flex-column">
                                                        <div className="d-flex font-size-base justify-content-between">
                                                            <span className="font-weight-semibold">Subtotal:</span>
                                                            <Price value={so?.subtotal} />
                                                        </div>
                                                        {so?.discount && so.discount !== '0.00' ? (
                                                            <div className="d-flex font-size-base justify-content-between">
                                                                <span className="font-weight-semibold">Discount:</span>
                                                                <span>
                                                                    -<Price value={Number(so?.discount)} />
                                                                </span>
                                                            </div>
                                                        ) : null}
                                                        <div className="d-flex font-size-base justify-content-between">
                                                            <span className="font-weight-semibold">Shipping:</span>
                                                            <Price value={so?.shipping} />
                                                        </div>
                                                        <div className="d-flex font-size-base justify-content-between">
                                                            <span className="font-weight-semibold">Tax:</span>
                                                            <Price value={so?.tax} />
                                                        </div>
                                                        <div className="d-flex font-size-base justify-content-between">
                                                            <span className="font-weight-semibold">Total:</span>
                                                            <Price value={so?.grand_total} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card>
                                            <div className="d-flex justify-content-end">
                                                <Button type="default">
                                                    <Link to={`/quick-turn/order-history/${so?.id}`}>
                                                        Order Details
                                                    </Link>
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Card>
                        );
                    })
                )}
            </div>
        </>
    );
};

export default observer(OrderHistory);
